import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Pipers from '../../../components/Pipers/Pipers';
import mediaQueries from '../../../utils/mediaQueries';

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background: ${({ theme, background }) => (background || theme.colors.secondary)};
`;
const HeaderContainer = styled.div``;
const PiperContainer = styled.div`
  max-width: 154px;
  max-height: 33px;
  @media ${mediaQueries.mdUp} {
    max-width: 340px;
    max-height: 73px;
  }
`;

const Header = ({ background }) => (
  <Container background={background}>
    <HeaderContainer>
      <PiperContainer>
        <Pipers.PiperLogoRoundedWhite />
      </PiperContainer>
    </HeaderContainer>
  </Container>
);

Header.propTypes = {
  background: PropTypes.string,
};

Header.defaultProps = {
  background: '',
};

export default Header;
